import IRechargeLayer from "./IRechargeLayer";
import CommonToggleContainer from "../../Common/CommonToggleContainer";
import UIManager from "../../Shared/UIManager";
import NetworkLogic from "../../Shared/NetworkLogic";
import ToggleItem from "../../Common/ToggleItem";
import SDKManager from "../../Shared/SDKManager";
import { Global } from "../../Shared/Global";
import Player from "../../Models/Player";

const {ccclass, property} = cc._decorator;

@ccclass
export default class RechargeOnlineLayer extends IRechargeLayer {
    @property(cc.Node)
    nodeTemplateFlag: cc.Node = null

    @property(CommonToggleContainer)
    toggleContainer: CommonToggleContainer = null
    
    @property(CommonToggleContainer)
    toggleMoneyContainer: CommonToggleContainer = null

    @property(cc.Node)
    nodeClear: cc.Node = null

    @property(cc.EditBox)
    ebMoney: cc.EditBox = null

    @property(cc.Label)
    lbMoney: cc.Label = null

    @property(cc.Label)
    lbRemark: cc.Label = null

    @property(cc.ScrollView)
    svLayer: cc.ScrollView = null

    private _decimal: number = 0

    onLoad () {
    }

    start () {
        NetworkLogic.getRandomDecimal(function (data) {
            this._decimal = parseFloat(data)
        }.bind(this))
    }

    onDisable () {
        this.toggleContainer.clear()
        this.svLayer.scrollToTop()
    }

    onDestroy () {
    }

    protected refreshData () {
        this.configs.forEach(cfg => {
            let toggle = this.toggleContainer.addDefaultToggle(cfg.clientChannelName.replace("/", "\n"), cfg)
            if (cfg.offerPercentage > 0) {
                let nodeFlag = cc.instantiate(this.nodeTemplateFlag)
                nodeFlag.position = cc.v2(toggle.node.width / 2 - 20, toggle.node.height / 2 - 5)
                nodeFlag.parent = toggle.node
                nodeFlag.getChildByName("num").getComponent(cc.Label).string = "赠" + cfg.offerPercentage + "%"
            }
        });
    }

    onBtnClick (event, userData) {
        if (userData === "clear") {
            this.ebMoney.string = ""
        }else if (userData === "recharege") {
            // 需要补全资料
            if (Player.getPy("visitorFillInfoTime").indexOf("3") !== -1 && Player.getPy("userType") === 2) {
                // 打开界面
                let hallUI = cc.find("Canvas/gameNode").getComponent("HallUI");
                hallUI.openChildUI(hallUI.pfbLoginCompleteInformation);
                return
            }
            
            let money = this.ebMoney.node.active ? this.ebMoney.string : this.lbMoney.string

            if (this.checkMoney(money)) {
                let config = this.toggleContainer.checkedToggle.getComponent(ToggleItem).userData
                UIManager.showLoadingUI()
                NetworkLogic.chargeByOnLine(money, config["id"], function (data) {
                    UIManager.hideLoadingUI()

                    // 4001 直接浏览器打开  4002 需要替换域名之后浏览器打开  5001  APP接入SDK打开支付宝
                    if (data.typeCode === "4001") {
                        cc.sys.openURL(data.url)
                        cc.director.emit(Global.UserEvent.OpenThirdPayment)
                    }else if (data.typeCode === "4002") {
                        this.replaceToFastUrl(data.url, function (url) {
                            cc.sys.openURL(url)
                            cc.director.emit(Global.UserEvent.OpenThirdPayment)
                        }.bind(this))
                    }else if (data.typeCode === "5001") {
                        cc.director.emit(Global.UserEvent.OpenThirdPayment)
                        SDKManager.alipay(data.url, function (data) {
                        }.bind(this))
                    }
                }.bind(this))
            }else {
                if (this.svLayer.node.convertToNodeSpaceAR(this.ebMoney.node.convertToWorldSpaceAR(cc.v2(0, 0))).y < -this.svLayer.node.height) {
                    this.svLayer.scrollToBottom(0.2)
                }
            }
        }
    }

    onSelectToggle (toggle, userData) {
        if (userData === "type") {
            this.reset()

            // 是否可以输入金额（0是1否）
            if (toggle.userData.isopenMonyInput === 0) {
                this.nodeClear.active = true
                this.ebMoney.node.active = true
                this.lbMoney.node.active = false
                this.ebMoney.placeholder = "请输入" + toggle.userData.limitRangeDown + "~" + toggle.userData.limitRangeUp + "之间的金额"
            }else {
                this.nodeClear.active = false
                this.ebMoney.node.active = false
                this.lbMoney.node.active = true
            }

            // 配置金额
            let fixedAmount = JSON.parse(toggle.userData.fixedAmount)
            fixedAmount.forEach(item => {
                this.toggleMoneyContainer.addDefaultToggle("￥" + item.QuickSelectionAmount, item)
            });

            // 提示信息
            this.lbRemark.string = toggle.userData.remark
        }else if (userData === "money") {
            // 是否打开小数点（0是1否）
            let decimal = this.toggleContainer.checkedToggle.userData["isopenDecimalPoint"] === 0 ? this._decimal : 0

            // 是否可以重复选择（0是1否）
            if (this.toggleContainer.checkedToggle.userData["isopenRepeatInput"] === 0) {
                this.lbMoney.string = (this.lbMoney.string ? parseInt(this.lbMoney.string) : 0) + toggle.userData.QuickSelectionAmount + decimal
                this.ebMoney.string = (this.ebMoney.string ? parseInt(this.ebMoney.string) : 0) + toggle.userData.QuickSelectionAmount + decimal
            }else {
                this.lbMoney.string = toggle.userData.QuickSelectionAmount + decimal
                this.ebMoney.string = toggle.userData.QuickSelectionAmount + decimal
            }
        }
    }

    private reset () {
        this.toggleMoneyContainer.clear()
        this.ebMoney.string = ""
        this.lbMoney.string = ""
    }

    private replaceToFastUrl (oldUrl: string, callback: Function) {
        UIManager.showLoadingUI()
        NetworkLogic.getPayDomainList(function (data) {
            let finished = false
            let domains = data.split(",")
            let errorTime = 0
            let domainsNum = domains.length

            let callFunc = function (url) {
                if (!finished) {
                    UIManager.hideLoadingUI()
                    finished = true
                    callback(url)
                }
            }

            domains.forEach(domain => {
                let xhr = new XMLHttpRequest()

                xhr["domain"] = domain
                xhr.responseType = "json"
                xhr.onload = function () {
                    callFunc(xhr["domain"] + oldUrl.substring(oldUrl.indexOf("/", 10)))
                }

                xhr.onerror = function () {
                    errorTime++

                    if (errorTime >= domainsNum) {
                        callFunc(oldUrl)
                    }
                }

                xhr.timeout = 20000
                xhr.ontimeout = function (e) {
                    callFunc(oldUrl)
                }

                xhr.open("GET", domain + "/ims/api/cheakDomain", true)
                xhr.send()
            });
        }.bind(this))
    }
}
